import { useMutation } from '@tanstack/react-query';

import { useToast } from '@aslanpay/portal-common-lib';

import SalaryReconciliationsApiHandler from 'app/services/salaryReconciliationsApiHandler';

import { SalaryReconciliationReportRequest } from 'app/types/salaryReconciliations';

/** Downloads a salary accrual reconciliation run's report as CSV, limited to one company when one is given. */
const useDownloadSalaryReconciliationReport = () => {
  const toast = useToast();

  return useMutation<void, Error, SalaryReconciliationReportRequest>(
    (request) => SalaryReconciliationsApiHandler.downloadReconciliationReport(request),
    {
      onSuccess: () => {
        toast({ position: 'top-right', status: 'success', title: 'Report downloaded' });
      },
      onError: () => {
        toast({
          position: 'top-right',
          status: 'error',
          title: 'Something went wrong',
          description: 'Sorry, it was not possible to download the report. Please try again.',
        });
      },
    }
  );
};

export default useDownloadSalaryReconciliationReport;
